export default __webpack_public_path__ + "static/media/phone-call.20a0ed42.png";